import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { ref, reactive, computed, onMounted, watch } from 'vue'
import type { Component } from 'vue'
import { setDrawerHost, type DrawerOptions, type DrawerPayload } from '@/lib/composable/drawer/drawerHostBridge'

type ResolvedOptions = Required<DrawerOptions>


export default /*@__PURE__*/_defineComponent({
  __name: 'DrawerHost',
  setup(__props, { expose: __expose }) {

const componentRef = ref<any>(null)

const DEFAULTS: ResolvedOptions = {
  width: 420,
  persistent: false,
  location: 'end'
}

const isOpen = ref(false)
const registry = new Map<string, Component>()
const wasOpen = ref(false)

const state = reactive<{
  component: string | Component | null
  props: Record<string, any>
  options: ResolvedOptions
  onClose?: () => void
}>({
  component: null,
  props: {},
  options: { ...DEFAULTS }
})

function resolve(c: string | Component | null): Component | null {
  if (!c) return null
  if (typeof c === 'string') return registry.get(c) ?? null
  return c
}

const resolvedComponent = computed(() => resolve(state.component))

function open(payload: DrawerPayload) {
  state.component = payload.component
  state.props = payload.props ?? {}
  state.options = { ...DEFAULTS, ...(payload.options ?? {}) }
  state.onClose = payload.onClose
  isOpen.value = true
  wasOpen.value = true
}

function close() {
  if (!isOpen.value) return
  isOpen.value = false
  wasOpen.value = false
  // call onClose after drawer animation completes
  requestAnimationFrame(() => setTimeout(() => state.onClose?.(), 0))
}

// Watch for drawer closing via Escape key or other external means
watch(isOpen, (newValue: boolean, oldValue: boolean) => {
  // If drawer was open and is now closed (e.g., via Escape key)
  if (wasOpen.value && oldValue === true && newValue === false) {
    wasOpen.value = false
    // call onClose after drawer animation completes
    requestAnimationFrame(() => setTimeout(() => state.onClose?.(), 0))
  }
  // Update wasOpen to track current state
  if (newValue === true) {
    wasOpen.value = true
  }
})

function register(name: string, comp: Component) {
  registry.set(name, comp)
}

function unregister(name: string) {
  registry.delete(name)
}

function getComponentInstance() {
  return componentRef.value
}

const api = { open, close, register, unregister, getComponentInstance }
__expose(api)

onMounted(() => {
  // Publish API to the shared bridge (no window usage)
  setDrawerHost(api)
})

return (_ctx: any,_cache: any) => {
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event)),
    location: state.options.location,
    width: state.options.width,
    temporary: !state.options.persistent,
    scrim: !state.options.persistent,
    class: "drawer-below-header"
  }, {
    default: _withCtx(() => [
      (resolvedComponent.value)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(resolvedComponent.value), _mergeProps({
            key: 0,
            ref_key: "componentRef",
            ref: componentRef
          }, state.props, {
            drawer: api,
            onClose: close
          }), null, 16))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "location", "width", "temporary", "scrim"]))
}
}

})